import { Container, Box, Text, chakra } from "@chakra-ui/react";
import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar";
import PageInfo from "@/components/PageInfo";
import provideMarkdownHtml from "@/utils/markdown-html-provider";

export default function TOS({ contentHtml }) {
  return (
    <>
      <PageInfo title="Terms of Service" themeColor="white" />
      <Navbar />
      <Container maxW={"container.md"}>
        <chakra.h1 textStyle={"pageHeader"}>Terms of Service</chakra.h1>
        <Text mt={4}>Last Updated: August 1, 2023</Text>
        <Box layerStyle="document" dangerouslySetInnerHTML={{ __html: contentHtml }} />
      </Container>
      <Footer />
    </>
  );
}

export const getStaticProps = provideMarkdownHtml("tos");
